import app from '../../../browser/addform/scripts/app';
import { react2angular } from 'react2angular';
import { DealRentDepositHintContainer } from './DealRentDepositHint.container';

app.component(
  'dealRentDepositHint',
  react2angular(
    DealRentDepositHintContainer,
    [],
    ['config', 'httpApi', 'logger'],
  ),
);
